export var isBasicClick = function isBasicClick(event) {
  return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};